module.exports = __webpack_public_path__ + "static/media/Special-offers.c2c350a6.svg";